// eslint-disable-next-line no-unused-vars
import React from 'react'
import ReactDOM from 'react-dom/client'
// eslint-disable-next-line no-unused-vars
import App from './containers/App'
// The exclamation point in the next line is needed by typescript, see https://bit.ly/3efZKNk
/* eslint-disable  @typescript-eslint/no-non-null-assertion */
const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
